import React from 'react';
import { Lightbulb } from 'lucide-react';

/* ======================================================
   Advice
   A labelled "Optiii advice" note: a practical recommendation the
   client can act on whether or not they engage us.
====================================================== */

const Advice = ({ children, style }) => (
  <div className="advice" style={style}>
    <span className="adviceTag" aria-label="Advice">
      <Lightbulb size={20} />
    </span>
    <div className="adviceText">{children}</div>
  </div>
);

export default Advice;
